import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa1ef06c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["window-container", { max: _ctx.max.state }]),
    style: _normalizeStyle({ left: _ctx.pos.x + 'px', top: _ctx.pos.y + 'px', padding: _ctx.border }),
    onClickCapture: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('active')))
  }, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "resize-border top",
        onMousedown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onMouseDown('resizeTop', $event))),
        style: _normalizeStyle({ width: _ctx.pos.w + 'px', left: _ctx.border, height: _ctx.border })
      }, null, 36),
      _createElementVNode("div", {
        class: "resize-border bottom",
        onMousedown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMouseDown('resizeBottom', $event))),
        style: _normalizeStyle({ width: _ctx.pos.w + 'px', left: _ctx.border, height: _ctx.border })
      }, null, 36),
      _createElementVNode("div", {
        class: "resize-border left",
        onMousedown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onMouseDown('resizeLeft', $event))),
        style: _normalizeStyle({ height: _ctx.pos.h + 'px', top: _ctx.border, width: _ctx.border })
      }, null, 36),
      _createElementVNode("div", {
        class: "resize-border right",
        onMousedown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onMouseDown('resizeRight', $event))),
        style: _normalizeStyle({ height: _ctx.pos.h + 'px', top: _ctx.border, width: _ctx.border })
      }, null, 36)
    ], 512), [
      [_vShow, !_ctx.max.state]
    ]),
    _createElementVNode("div", {
      class: "box",
      style: _normalizeStyle({ width: _ctx.pos.w + 'px', height: _ctx.pos.h + 'px' })
    }, [
      _createElementVNode("div", {
        class: "header",
        onMousedown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onMouseDown('move', $event)))
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.windowDatum.title), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_sc_icon, {
            class: "btn",
            type: "LineOutlined",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('minimize')))
          }),
          _withDirectives(_createVNode(_component_sc_icon, {
            class: "btn",
            type: "ExpandOutlined",
            onClick: _ctx.maximize
          }, null, 8, ["onClick"]), [
            [_vShow, !_ctx.max.state]
          ]),
          _withDirectives(_createVNode(_component_sc_icon, {
            class: "btn",
            type: "CompressOutlined",
            onClick: _ctx.normalize
          }, null, 8, ["onClick"]), [
            [_vShow, _ctx.max.state]
          ]),
          _createVNode(_component_sc_icon, {
            class: "btn",
            type: "CloseOutlined",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
          })
        ])
      ], 32),
      _createVNode(_component_a_config_provider, { locale: _ctx.local }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "body",
            style: _normalizeStyle({padding: _ctx.windowDatum.padding + 'px'})
          }, [
            (_ctx.windowDatum.content.type === 'route')
              ? (_openBlock(), _createBlock(_component_router_view, {
                  key: _ctx.router.currentRoute.path
                }))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.windowDatum.content.component), _normalizeProps(_mergeProps({ key: 1 }, _ctx.windowDatum.content.props)), null, 16))
          ], 4)
        ]),
        _: 1
      }, 8, ["locale"])
    ], 4)
  ], 38))
}